export const SIDEBAR = {
  width: 248,
  collapsedWidth: 87,
  mobileHeight: 75,
  mobileTab: 40,
  iconWidth: 40,
  itemTextMargin: 8,
  basePadding: 8,
};

export const TOPBAR = {
  height: 65,
  mobileHeight: 50,
};

export const TRANSITION_SPEED = 0.3;
export const APP_NAME = "Shell";

export const zIndex = {
  under: -1,
  bottomLayer: 1,
  overContent: 11,
  overContentMenu: 12,
  overSideMenu: 13,
  overlayMenu: 14,
};
